




























import Vue from 'vue'
import Modal from '@/components/Modal'
import './LegalUpdatePrompt.scss'
import SubscribeLegalInfo from '@/mixins/SubscribeLegalInfo'
import moment from 'moment'
moment().format()

//Show a dialog for the user to accept new terms when there is a legal doc update
export default Vue.extend({
  name: 'LegalUpdatePrompt',
  computed: {
    tosUrl (): string {
      return this.$store.direct.state.admin.legalinfo.tosUrl
    },
    privacyUrl (): string {
      return this.$store.direct.state.admin.legalinfo.privacyUrl
    },
    tosVersion (): number {
      return this.$store.direct.state.admin.legalinfo.tosLastPublished.seconds
    },
    privacyVersion (): number {
      return this.$store.direct.state.admin.legalinfo.privacyLastPublished.seconds
    },
    tosUserVersion (): number {
      return this.$store.direct.state.user.legalAgreements.tosVersion
    },
    privacyUserVersion (): number {
      return this.$store.direct.state.user.legalAgreements.privacyVersion
    },
    lastUpdateDialog (): number | null {
      return this.$store.direct.state.user.legalAgreements.lastUpdateDialog
    },
    showLegalPrompt (): boolean {
      /* Only show agreement dialog if there is an updated doc version
      and it's been over 15 minutes since the user was last asked.
      Inherently accounts for non-existing values, as Store defaults them to 0. */
      if (this.lastUpdateDialog !== null 
      && (this.tosVersion > this.tosUserVersion || this.privacyVersion > this.privacyUserVersion) 
      && moment().subtract(15, 'minutes').unix() > this.lastUpdateDialog) {
        return true
      }
      return false
    },
    dialogType (): string {
      //If first time accepting terms, e.g., existing users
      if (this.tosUserVersion === 0 || this.privacyUserVersion === 0) {
        return 'initial'
      }

      //If both terms updated
      else if (this.tosVersion > this.tosUserVersion && this.privacyVersion > this.privacyUserVersion) {
        return 'all'
      }

      //If only ToS updated
      else if (this.tosVersion > this.tosUserVersion && this.privacyVersion <= this.privacyUserVersion) {
        return 'tos'
      }

      //If only Privacy Policy updated
      else if (this.tosVersion <= this.tosUserVersion && this.privacyVersion > this.privacyUserVersion) {
        return 'privacy'
      }
      return 'initial'
    }
  },
  mixins: [SubscribeLegalInfo],
  methods: {
    updateUserLegalProps (onlyDialogTime: boolean = false) {
      //Match user's legal versions with latest if param is true.
      //Else only update user's lastUpdateDialog time
      this.$store.direct.dispatch.user.updateLegalAgreements(onlyDialogTime)
     }
  },
  components: {
    Modal
  }
})
